var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"1800px"}},[_vm._v(_vm._s(_vm.$t('other.a1983')))])}
var staticRenderFns = []

export { render, staticRenderFns }